export const FILE_TYPES_ACCEPT = {
  LOGO: 'image/png, image/jpeg, image/svg',
  STATUTE: '.pdf',
  NON_POLITICAL_AFFILIATION: '.pdf',
  BALANCE_SHEET: '.pdf',
  EXCEL: '.xls,.xlsx',
};
